import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import UserCredentialsSection from '../dettaglio_responsabilesicurezza/UserCredentialsSection';
import { AUTH_OPTIONS } from '../../../auth/auth.options';

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    marginTop: '10px',
    marginBottom: '10px',
    paddingTop: '16px',
    paddingBottom: '16px',
  },
  fieldsContainer: {
    marginTop: '10px',
    marginBottom: '10px',
    padding: '10px',
  },
  gridContainer: {
    paddingRight: '10px',
    paddingLeft: '10px',
    paddingBottom: '10px',
  },
  textfield: {
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '12px',
    width: '250px',
  },
}));

const ResponsabileSicurezzaForm = ({
  handleAuthTypeChange,
  handleChangeResponsabileSicurezza,
  handleClickShowPassword,
  record,
  showPassword1,
  showPassword2,
  textFieldsDisabled,
  validationErrors,
}) => {
  const classes = useStyles();

  const rs = record?.esercizio?.responsabileSicurezza;

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={12}
      xl={12}
      className={classes.sectionContainer}
    >
      <Typography
        variant="h6"
        style={{ paddingTop: '6px', paddingBottom: '6px' }}
      >
        Aggiungi responsabile sicurezza associato al nuovo esercizio
      </Typography>
      <Grid container>
        <UserCredentialsSection
          authOptions={AUTH_OPTIONS}
          record={rs}
          validationErrors={validationErrors}
          disableForm={textFieldsDisabled}
          showPassword1={showPassword1}
          showPassword2={showPassword2}
          onToggleShowPassword1={() => handleClickShowPassword('showPassword1')}
          onToggleShowPassword2={() => handleClickShowPassword('showPassword2')}
          onFieldChange={(name, value) =>
            handleChangeResponsabileSicurezza({ target: { name, value } })
          }
          onAuthTypeChange={handleAuthTypeChange}
        />
      </Grid>
    </Grid>
  );
};

ResponsabileSicurezzaForm.propTypes = {
  handleAuthTypeChange: PropTypes.func.isRequired,
  handleChangeResponsabileSicurezza: PropTypes.func.isRequired,
  handleClickShowPassword: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired,
  showPassword1: PropTypes.bool.isRequired,
  showPassword2: PropTypes.bool.isRequired,
  textFieldsDisabled: PropTypes.bool.isRequired,
  validationErrors: PropTypes.object.isRequired,
};

export default ResponsabileSicurezzaForm;
